/* global debounce */
if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.disclosure = this.closest('details');

      if (this.disclosure && this.disclosure.matches('.cart-note-disclosure')) {
        this.cartNoteToggle = this.disclosure.querySelector('.js-show-note');
        this.cartNoteToggleText = this.disclosure.querySelector('.js-show-note-text');
      }

      this.charCount = this.querySelector('.js-char-count');
      this.savedIndicator = this.closest('.cart-drawer__gift-message-panel, .disclosure__content')
        ?.parentElement?.querySelector('.cart-drawer__gift-saved');
      this.saveBtn = this.closest('.cart-drawer__gift-message-panel, .disclosure__content')
        ?.parentElement?.querySelector('.js-save-gift-message');

      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.init();
    }

    init() {
      this.debouncedHandleNoteChange = debounce(this.handleNoteChange.bind(this), 300);
      // Save as soon as possible, avoid link-click not providing time to save
      this.addEventListener('input', this.debouncedHandleNoteChange);

      if (this.saveBtn) {
        this.saveBtn.addEventListener('click', () => {
          this.showSavedConfirmation();
          const details = this.closest('details');
          if (details) {
            setTimeout(() => { details.removeAttribute('open'); }, 800);
          }
        });
      }
    }

    handleNoteChange(evt) {
      const toggleTarget = this.cartNoteToggleText || this.cartNoteToggle;
      if (toggleTarget) {
        const label = evt.target.value ? theme.strings.editCartNote : theme.strings.addCartNote;
        if (toggleTarget.textContent !== label) toggleTarget.textContent = label;
      }

      if (this.charCount) {
        this.charCount.textContent = evt.target.value.length;
      }

      this.fetchRequestOpts.body = JSON.stringify({ note: evt.target.value });
      fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
    }

    showSavedConfirmation() {
      if (this.savedIndicator) {
        this.savedIndicator.style.opacity = '1';
        setTimeout(() => { this.savedIndicator.style.opacity = '0'; }, 1500);
      }
    }
  }

  customElements.define('cart-note', CartNote);
}
